import { render, staticRenderFns } from "./QuizResult.vue?vue&type=template&id=44cc2498"
import script from "./QuizResult.vue?vue&type=script&lang=js"
export * from "./QuizResult.vue?vue&type=script&lang=js"
import style0 from "./QuizResult.vue?vue&type=style&index=0&id=44cc2498&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports